module.exports = __webpack_public_path__ + "static/media/3.ea098003.jpg";